import { maskPhone } from './normalize';
import { Telemetry, TelemetryBus, TelemetryEvent } from './types';

export interface TelemetryOptions {
  enableTelemetry: boolean;
  telemetryBus?: TelemetryBus;
}

export class PhoneEnrichmentTelemetry implements Telemetry {
  private enabled: boolean;
  private telemetryBus?: TelemetryBus;

  constructor(options: TelemetryOptions) {
    this.enabled = options.enableTelemetry;
    this.telemetryBus = options.telemetryBus;
  }

  private emit(event: TelemetryEvent): void {
    if (!this.enabled) {
      return;
    }

    try {
      if (this.telemetryBus) {
        this.telemetryBus.track(event.eventName, event.properties);
      } else {
        console.log('[Telemetry]', event.eventName, event.properties);
      }
    } catch (error) {
      console.warn('[Telemetry] Failed to emit event', error);
    }
  }

  emitAttempt(phone: string, cacheTier: 'hot' | 'warm' | 'miss'): void {
    this.emit({
      eventName: 'phone_enrichment_attempt',
      properties: {
        phone: maskPhone(phone),
        cacheTier,
        timestamp: Date.now(),
      },
      timestamp: Date.now(),
    });
  }

  emitSuccess(phone: string, latencyMs: number, source: 'cache' | 'api'): void {
    this.emit({
      eventName: 'phone_enrichment_success',
      properties: {
        phone: maskPhone(phone),
        latencyMs,
        source,
        timestamp: Date.now(),
      },
      timestamp: Date.now(),
    });
  }

  emitMiss(phone: string, errorCategory: string): void {
    this.emit({
      eventName: 'phone_enrichment_miss',
      properties: {
        phone: maskPhone(phone),
        errorCategory,
        timestamp: Date.now(),
      },
      timestamp: Date.now(),
    });
  }

  emitBatch(batchSize: number, latencyMs: number): void {
    this.emit({
      eventName: 'phone_enrichment_batch',
      properties: {
        batchSize,
        latencyMs,
        timestamp: Date.now(),
      },
      timestamp: Date.now(),
    });
  }
}
